/* eslint jsx-a11y/no-static-element-interactions: 0 */
import Auth from '@aws-amplify/auth';
import {
  Button,
  Modal,
  Header,
  Icon,
} from 'semantic-ui-react';
import React, {
  Component,
} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { fetchM } from '../actions/fetchM';
import { flashErrorMessage, flashSuccessMessage } from '../actions/flash';

export default class CreditCheckManageButton extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    index: PropTypes.number,
    companyAppCredit: PropTypes.shape({
      credit: PropTypes.string,
    }),
    data: PropTypes.shape({
      customer: PropTypes.object,
    }),
    isAgent: PropTypes.bool,
    creditsAmount: PropTypes.number,
  }
  constructor(props) {
    super(props);
    const data = Object.assign({}, props.data);
    const modal = {
      isOpen: false,
      header: '',
      headerIcon: 'warning sign',
      message: '',
      actionButtonText: 'Yes',
      customerName: '',
      customerID: '',
      customerCreditReportID: '',
      token: '',
      type: '',
    };
    this.state = {
      creditReport: null,
      data,
      loading: false,
      modal,
      updating: false,
    };
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, res);
    });
  }
  setUpdating(updating = false) {
    return new Promise((res) => {
      this.setState({ updating }, res);
    });
  }
  async creditCheckToken() {
    const { store } = this.context;
    await this.setLoading(true);
    let res;
    try {
      res = await store.dispatch(fetchM(`/customers/${this.state.modal.customerID}/credit_reports/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const reportToken = res.headers.get('X-Csrf-Token');
      this.setState({ reportToken });
    }
    await this.setLoading(false);
  }
  handlerGenerateCreditCheck = () => {
    this.generateCreditCheck();
  }
  async generateCreditCheck() {
    const { store } = this.context;
    await this.setUpdating(true);

    let res;
    try {
      const jwtToken = (await Auth.currentSession()).getAccessToken().getJwtToken();
      res = await store.dispatch(fetchM(`/customers/${this.state.modal.customerID}/credit_reports/${this.state.modal.customerCreditReportID}/status/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-JWT-Token': jwtToken,
        },
      }));
    } catch (err) {
      await this.setUpdating(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const { modal } = this.state;
      modal.isOpen = false;
      const creditReport = await res.json();
      await this.setComponentState({
        modal,
        creditReport,
      });
      store.dispatch(flashSuccessMessage({ header: 'Credit score generating', message: `${this.state.modal.customerName}'s credit report sent` }));
      window.location.reload();
    }
    await this.setUpdating(false);
  }

  handleCloseModal = () => {
    const modal = Object.assign({}, this.state.modal);
    modal.isOpen = false;
    this.setState({ modal });
  }
  handleGetSupport = () => {
    const modal = Object.assign({}, this.state.modal);
    modal.isOpen = false;
    this.setState({ modal }, () => {
      window.zE('webWidget', 'reset');
      window.zE('webWidget', 'open');
    });
  }
  handleOpenModal = (
    index,
    type,
    customerName,
    customerID,
    customerCreditReportID,
    actionButtonText,
    headerIcon,
    header,
    message) => {
    const modal = Object.assign({}, this.state.modal);
    if (type === 'generate') {
      this.creditCheckToken();
    }
    modal.index = index;
    modal.type = type;
    modal.customerCreditReportID = customerCreditReportID;
    modal.customerName = customerName;
    modal.customerID = customerID;
    modal.isOpen = true;
    modal.header = header;
    modal.message = message;
    modal.headerIcon = headerIcon;
    modal.actionButtonText = actionButtonText;
    this.setState({ modal });
  }
  buttonText = (status, updating, creditReport) => {
    const { isAgent } = this.props;
    let text = 'Generate now!';
    if (updating || status === 'request_pending' || status === 'request_mhub_ctos_received' ||
      (!updating && creditReport && creditReport.mCtosXMLStatusID === 'request_pending') || isAgent) {
      text = 'Pending';
    }
    if (status === 'request_ctos_muliple_entities') {
      text = 'Multiple entities';
    }
    return text;
  }
  disabledCheck = (updating, creditReport, data) => {
    const { isAgent } = this.props;
    return (
      updating ||
      (!updating && creditReport && creditReport.mCtosXMLStatusID === 'request_pending') ||
      data.consentDsrDocumentID === '' ||
      !data.isAgreedToDSRTerms ||
      (data.customer && (
      data.customer.icFrontDocumentID === '' ||
      data.customer.icBackDocumentID === '' ||
      data.customer.incomeID === '')) ||
      data.mCtosXMLStatusID === 'request_pending' ||
      data.mCtosXMLStatusID === 'request_mhub_ctos_received' ||
      isAgent
    );
  }
  buttonCheck = () => {
    const { companyAppCredit, data, isAgent } = this.props;
    const { updating, creditReport } = this.state;
    const status = data.mCtosXMLStatusID;
    switch (status) {
      case 'request_ctos_bad_request':
        return (
          <div
            className="clickable"
            onClick={(e) => {
              e.preventDefault();
              this.handleOpenModal(
                this.props.index,
                'notAvailable',
                data.customer.customerDetail.name,
                data.customerID,
                data.id,
                'Yes',
                '/assets/images/icons/red_alert.svg',
                'Wrong Info',
                <span>
                  <p>
                    {data.customer.customerDetail.name}&nbsp;
                    currently does not have credit
                    report with CTOS.
                  </p>
                  <p>
                    How do we resolve this?
                  </p>
                  <ul style={{ marginLeft: '1.5em' }}>
                    <li>Check IC Number validity</li>
                    <li>Make sure name matches IC</li>
                  </ul>
                </span>,
              );
            }
          }
            role="button"
          >
            <img className="icon-credit" alt="alert" src="/assets/images/icons/red_alert.svg" />
            &nbsp;Wrong Info
          </div>
        );
      case 'request_ctos_not_available':
        return (
          <div
            className="clickable"
            onClick={(e) => {
              e.preventDefault();
              this.handleOpenModal(
                this.props.index,
                'notAvailable',
                data.customer.customerDetail.name,
                data.customerID,
                data.id,
                'Yes',
                '/assets/images/icons/red_alert.svg',
                'Report is not available',
                <span>
                  <p>
                    {data.customer.customerDetail.name}&nbsp;
                    currently does not have
                    report with CTOS.
                  </p>
                  <p>
                    How do we resolve this?
                  </p>
                  <ul style={{ marginLeft: '1.5em' }}>
                    <li>
                      <Button
                        compact
                        size="mini"
                        color={
                          data.mCtosXMLStatusID === 'request_pending' ||
                          data.mCtosXMLStatusID === 'request_mhub_ctos_received' || updating ||
                            (!updating && creditReport && creditReport.mCtosXMLStatusID === 'request_pending') || isAgent ? 'orange' : 'green'}
                        className="button-credit-check"
                        disabled={this.disabledCheck(updating, creditReport, data)}
                        onClick={(e) => {
                          e.preventDefault();
                          if (!this.props.creditsAmount ||
                          (this.props.creditsAmount && this.props.creditsAmount < 10)) {
                            this.handleOpenModal(
                              this.props.index,
                              'insufficientCredit',
                              data.customer.customerDetail.name,
                              data.customerID,
                              data.id,
                              'Top Up',
                              '/assets/images/icons/red_alert.svg',
                              'Insufficient credits',
                              <span>
                                <p>
                                  Not enough balance to perform a Credit Check. Please contact the admin
                                </p>
                              </span>,
                            );
                          } else {
                            this.handleOpenModal(
                              this.props.index,
                              'generate',
                              data.customer.customerDetail.name,
                              data.customerID,
                              data.id,
                              'Yes',
                              'dashboard',
                              <span>Generate Credit score?
                              </span>,
                              <span>
                                {data.customer.customerDetail.name}&apos;{'s '}credit score will be generate.
                              </span>,
                            );
                          }
                        }}
                      >
                        {
                            this.buttonText(
                              data.mCtosXMLStatusID, updating, creditReport,
                            )
                        }
                      </Button>
                    </li>
                    <li>If the issue does not solve. Please contact the admin.</li>
                  </ul>
                </span>,
              );
            }
          }
            role="button"
          >
            <img className="icon-credit" alt="alert" src="/assets/images/icons/red_alert.svg" />
            &nbsp;Report not available
          </div>
        );
      case 'request_ctos_report_empty':
        return (
          <div
            className="clickable"
            onClick={(e) => {
              e.preventDefault();
              this.handleOpenModal(
                this.props.index,
                'notAvailable',
                data.customer.customerDetail.name,
                data.customerID,
                data.id,
                'Yes',
                '/assets/images/icons/red_alert.svg',
                'Report is empty',
                <span>
                  <p>
                    {data.customer.customerDetail.name}&nbsp;
                    currently does not have
                    report with CTOS.
                  </p>
                  <p>
                    How do we resolve this?
                  </p>
                  <ul style={{ marginLeft: '1.5em' }}>
                    <li>
                      <Button
                        compact
                        size="mini"
                        color={
                          data.mCtosXMLStatusID === 'request_pending' ||
                          data.mCtosXMLStatusID === 'request_mhub_ctos_received' || updating ||
                            (!updating && creditReport && creditReport.mCtosXMLStatusID === 'request_pending') || isAgent ? 'orange' : 'green'}
                        className="button-credit-check"
                        disabled={this.disabledCheck(updating, creditReport, data)}
                        onClick={(e) => {
                          e.preventDefault();
                          if (!this.props.creditsAmount ||
                          (this.props.creditsAmount && this.props.creditsAmount < 10)) {
                            this.handleOpenModal(
                              this.props.index,
                              'insufficientCredit',
                              data.customer.customerDetail.name,
                              data.customerID,
                              data.id,
                              'Top Up',
                              '/assets/images/icons/red_alert.svg',
                              'Insufficient credits',
                              <span>
                                <p>
                                  Not enough balance to perform a Credit Check. Please contact the admin
                                </p>
                              </span>,
                            );
                          } else {
                            this.handleOpenModal(
                              this.props.index,
                              'generate',
                              data.customer.customerDetail.name,
                              data.customerID,
                              data.id,
                              'Yes',
                              'dashboard',
                              <span>Generate Credit score?
                              </span>,
                              <span>
                                {data.customer.customerDetail.name}&apos;{'s '}credit score will be generate.
                              </span>,
                            );
                          }
                        }}
                      >
                        {
                            this.buttonText(
                              data.mCtosXMLStatusID, updating, creditReport,
                            )
                        }
                      </Button>
                    </li>
                    <li>If the issue does not solve. Please contact the admin.</li>
                  </ul>
                </span>,
              );
            }
          }
            role="button"
          >
            <img className="icon-credit" alt="alert" src="/assets/images/icons/red_alert.svg" />
            &nbsp;Report is empty
          </div>
        );
      case 'request_ctos_muliple_entities':
        return (
          <Link
            className="clickable"
            to={`/customers/${data.customerID}/credit_checks/${data.id}/multiple_entities/`}
          >
            <img className="icon-credit" alt="alert" src="/assets/images/icons/red_alert.svg" />
            &nbsp;Multiple entities
          </Link>
        );
      // case 'new':
      //   return (
      //     <div
      //       className="clickable"
      //       onClick={(e) => {
      //         e.preventDefault();
      //         this.handleOpenModal(
      //           this.props.index,
      //           'notAvailable',
      //           data.customer.customerDetail.name,
      //           data.customerID,
      //           data.id,
      //           'Yes',
      //           '/assets/images/icons/yellow_alert_cc.svg',
      //           'Incomplete Info',
      //           <span>
      //             <p>
      //               {data.customer.customerDetail.name}&nbsp;
      //               did not complete all the credit check steps
      //             </p>
      //             <p>
      //               How do we resolve this?
      //             </p>
      //             <ul style={{ marginLeft: '1.5em' }}>
      //               <li>Make sure all the steps are completed and successfully submitted</li>
      //             </ul>
      //           </span>,
      //         );
      //       }
      //     }
      //       role="button"
      //     >
      //       <img className="icon-credit" alt="alert" src="/assets/images/icons/yellow_alert_cc.svg" />
      //       &nbsp;Incomplete Info
      //     </div>
      //   );
      default:
        return (
          <Button
            compact
            size="mini"
            color={
              data.mCtosXMLStatusID === 'request_pending' ||
              data.mCtosXMLStatusID === 'request_mhub_ctos_received' || updating ||
                (!updating && creditReport && creditReport.mCtosXMLStatusID === 'request_pending') || isAgent ? 'orange' : 'green'}
            className="button-credit-check"
            disabled={this.disabledCheck(updating, creditReport, data)}
            onClick={(e) => {
              e.preventDefault();

              if (!this.props.creditsAmount ||
              (this.props.creditsAmount && this.props.creditsAmount < 10)) {
                this.handleOpenModal(
                  this.props.index,
                  'insufficientCredit',
                  data.customer.customerDetail.name,
                  data.customerID,
                  data.id,
                  'Top Up',
                  '/assets/images/icons/red_alert.svg',
                  'Insufficient credits',
                  <span>
                    <p>
                      Not enough balance to perform a Credit Check. Please contact the admin
                    </p>
                  </span>,
                );
              } else {
                this.handleOpenModal(
                  this.props.index,
                  'generate',
                  data.customer.customerDetail.name,
                  data.customerID,
                  data.id,
                  'Yes',
                  'dashboard',
                  <span>Generate Credit score?
                  </span>,
                  <span>
                    {data.customer.customerDetail.name}&apos;{'s '}credit score will be generate.
                  </span>,
                );
              }
            }}
          >
            {
                this.buttonText(
                  data.mCtosXMLStatusID, updating, creditReport,
                )
            }
          </Button>
        );
    }
  }
  render() {
    const { modal, updating, creditReport } = this.state;
    return (
      <div>
        <Modal className="manage manage-credit-check" dimmer closeOnDimmerClick open={modal.isOpen} size="small">
          {
            modal.type !== 'generate' ?
              <Header>
                <img className="icon-credit" alt="alert" src={modal.headerIcon} />
                <Header.Content>
                  {modal.header}
                </Header.Content>
              </Header> :
              <Header icon={modal.headerIcon} content={modal.header} />
        }
          <Modal.Content>
            <h4>{modal.message}</h4>
          </Modal.Content>
          <Modal.Actions>
            {
              modal.type !== 'notAvailable' ?
                <Button onClick={this.handleCloseModal} color="grey">
                  <Icon name="remove" /> {modal.type === 'generate' ? 'No' : 'Cancel'}
                </Button> :
                <Button onClick={this.handleCloseModal} color="green">
                  <Icon name="checkmark" /> Ok
                </Button>
            }
            {
              modal.type === 'generate' ?
                <Button
                  onClick={this.handlerGenerateCreditCheck}
                  color="green"
                  disabled={updating ||
                    (!updating && creditReport && creditReport.mCtosXMLStatusID === 'request_pending')}
                >
                  <Icon name="checkmark" /> {modal.actionButtonText}
                </Button> :
                null
            }
            {
              modal.type === 'insufficientCredit' ?
                <Button
                  color="green"
                  as="a"
                  onClick={this.handleGetSupport}
                >
                  <Icon name="plus" />
                  {modal.actionButtonText}
                </Button> :
                null
            }
          </Modal.Actions>
        </Modal>
        {
        this.buttonCheck()
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CreditCheckManageButton.jsx